import warningIconGradient from "@assets/images/exclamation.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    title: {
      color: "#333",
      marginRight: "4px",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px",
      marginBottom: "12px"
    },
    checkCircleimg: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },

    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    message: {
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      display: "flex"
    },
    dialog: {
      width: "420px",
      padding: theme.spacing(3),
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      minHeight: "200px", // Set a min-height to prevent the dialog from collapsing
      justifyContent: "space-between"
    },
    titles: {
      fontSize: "20px",
      fontWeight: 700
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "12px",
      marginBottom: "12px"
    },
    btnBgGradient: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      border: "none",
      color: "#ffffff",
      height: "48px",
      marginTop: "32px",
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      },
      "&:hover": {
        border: "none"
      }
    }
  }),
  { name: "DialogNoData" }
);

export interface Props {
  title: string;
  isOpen: boolean;
  okText: string;
  onClose: () => void;
  content: string;
}

const DialogNoData = ({ isOpen, onClose, title, content, okText }: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box className={classes.dialog}>
        <div className={classes.checkCircleimg}>
          <img
            src={warningIconGradient}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {intl.formatMessage(
              {
                defaultMessage: "{title}",
                description: "title"
              },
              { title }
            )}
          </Typography>
        </div>
        <div>
          <Typography className={classes.message}>
            {intl.formatMessage(
              {
                defaultMessage: "{content}",
                description: "content"
              },
              { content }
            )}
          </Typography>
        </div>

        <Button
          id="closeButton"
          data-testid="close-modal-no-data-button"
          className={classes.btnBgGradient}
          onClick={onClose}
        >
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage(
              {
                defaultMessage: "{okText}",
                description: "Close"
              },
              { okText }
            )}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogNoData;
